module.exports = __webpack_public_path__ + "img/Stage_3.ec185d1c.svg";